var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearchIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55028 7.18127C5.76344 6.28536 6.54814 5.57233 7.40521 5.36484C7.80599 5.29387 8.10881 4.95416 8.10881 4.54725C8.10881 4.09102 7.72503 3.71771 7.25601 3.71771C6.64193 3.71771 5.70803 4.21962 5.00875 4.90403C4.32642 5.57592 3.84454 6.37659 3.84454 7.036C3.84454 7.49223 4.24119 7.86554 4.7102 7.86554C5.12768 7.86554 5.47776 7.57097 5.55028 7.18113V7.18127ZM16.7311 18.584C17.3915 19.2269 18.4666 19.2269 19.1271 18.584C19.7885 17.9412 19.7885 16.8958 19.1271 16.2571L14.2319 11.4915C14.945 10.3795 15.3581 9.0691 15.3581 7.65879C15.3581 3.64763 12.0192 0.399809 7.89561 0.399809C3.77199 0.399809 0.433105 3.64771 0.433105 7.65879C0.433105 11.67 3.77206 14.9178 7.89561 14.9178C9.34122 14.9178 10.693 14.515 11.8358 13.8223L16.7311 18.584ZM7.89572 12.8432C4.95341 12.8432 2.56557 10.52 2.56557 7.6584C2.56557 4.79634 4.95348 2.47362 7.89572 2.47362C10.838 2.47362 13.2259 4.79641 13.2259 7.6584C13.2254 10.52 10.8375 12.8432 7.89572 12.8432Z",
    fill: "#E2A400"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SearchIcon.c3d37d5e.svg";
export { ForwardRef as ReactComponent };